import { gql } from "@apollo/client";

export const GET_USER = gql`
  query GetUser {
    getUser {
      email
      name
      phoneNumber
      company
      isAdmin
    }
  }
`;
